import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

import AppDrawer from 'src/components/layout/AppDrawer.vue'
import AppFooter from 'src/components/layout/AppFooter.vue'
import AppHeader from 'src/components/layout/AppHeader.vue'
import BreadCrumb from 'src/components/layout/BreadCrumb.vue'
import useWindowEvent from 'src/hooks/windowEvent'
import { GetterTypes as AuthGetterTypes } from 'src/types/stores/auth'
import { LoadingBar } from 'quasar'
import { dom, QBreadcrumbs } from 'quasar'
import { ref, watch } from 'vue'
import { useAuthStore } from 'src/stores/modules/auth'
import { useCoreStore } from './stores/modules/core'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const authStore = useAuthStore()
const coreStore = useCoreStore()

const breadcrumb = ref<QBreadcrumbs>()
const pagepadding = ref(0)

function adjustHeight() {
  if (!breadcrumb.value) {
    pagepadding.value = 0
    return
  }

  const component = breadcrumb.value
  const el = component.$el as HTMLElement

  pagepadding.value = dom.height(el)
}

//loading bar
watch(
  () => coreStore.ajaxLoading,
  (loading) => {
    if (loading) {
      LoadingBar.start()
    } else {
      LoadingBar.stop()
    }
  },
  { immediate: true }
)

//fix height
useWindowEvent('resize', adjustHeight, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, { view: "lHh Lpr lFf" }, {
    default: _withCtx(() => [
      (_unref(authStore)[_unref(AuthGetterTypes).IS_AUTHENTICATED])
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(AppHeader),
            _createVNode(AppDrawer),
            _createVNode(AppFooter)
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          (_unref(authStore)[_unref(AuthGetterTypes).IS_AUTHENTICATED])
            ? (_openBlock(), _createBlock(BreadCrumb, {
                key: 0,
                ref_key: "breadcrumb",
                ref: breadcrumb
              }, null, 512))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            style: _normalizeStyle({ 'padding-top': `${pagepadding.value}px` })
          }, [
            _createVNode(_component_router_view)
          ], 4)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})